import { FieldPath, useFormContext } from 'react-hook-form';

import { PropertyGridRow } from '../rows/PropertyGridRow.tsx';
import { TitleRow } from '../rows/TitleRow.tsx';
import {
  PropertyGridSectionProps as BasePropertyGridSectionProps,
  PropertyGridField,
  PropertyGridForm,
} from '../types.ts';

type PropertyGridSectionProps = BasePropertyGridSectionProps & {
  title: string;
  fields: PropertyGridField[];
};

export const PropertyGridSection = ({
  fields,
  title,
  isRemovable,
  onRemove,
  ...propertySectionProps
}: PropertyGridSectionProps) => {
  const { columnIndex, fieldTypes, feature } = propertySectionProps;

  const { watch } = useFormContext<PropertyGridForm>();

  const propertyId = watch(`columns.${columnIndex}.propertyId`);

  let sectionIsNone = false;

  if (propertyId !== 'subject' && feature) {
    const hasFeatureKey = feature === 'manualCost' ? 'hasManualCost' : `${feature}.hasFeature`;

    const hasFeature = watch(
      `columns.${columnIndex}.propertyData.editableData.improvements.${hasFeatureKey}` as FieldPath<PropertyGridForm>,
    ) as boolean;

    if (!hasFeature) sectionIsNone = true;
  }

  return (
    <>
      <TitleRow
        columnIndex={columnIndex}
        fieldTypes={fieldTypes}
        title={title}
        feature={feature}
        isRemovable={isRemovable}
        onRemove={onRemove}
      />
      {fields.map((field) => (
        <PropertyGridRow
          key={field.label}
          field={field}
          sectionIsNone={sectionIsNone}
          {...propertySectionProps}
        />
      ))}
    </>
  );
};
